// extracted by mini-css-extract-plugin
export default {"container":"CellGroup_container__6Xigm"};